import type { StorageAdapter } from "./StorageAdapter.ts";
import {
  LocalStorageAdapter,
  isLocalStorageAvailable,
} from "./LocalStorageAdapter.ts";
import { MemoryStorageAdapter } from "./MemoryStorageAdapter.ts";

/**
 * Pick the storage backend at boot (BL-85): the real `localStorage`-backed
 * adapter when storage is usable, otherwise an in-memory fallback so the
 * game boots and runs (saves just don't persist) instead of white-screening.
 *
 * Either way the returned adapter never throws on a storage operation, so a
 * blocked/sandboxed/private-mode context degrades gracefully.
 */
export function createStorageAdapter(prefix: string = "aiw_"): StorageAdapter {
  if (isLocalStorageAvailable()) {
    return new LocalStorageAdapter(prefix);
  }
  console.warn(
    "[storage] localStorage unreachable — using in-memory fallback (saves won't persist this session)",
  );
  return new MemoryStorageAdapter(prefix);
}
